/*CRUD Form class to create new, edit or delete a given record.
* DataKey is the record key for the record to be managed.*/

import PageClass from '../defaultPage/pageClass';
import CrudToolbar from './crudToolbar';

export default PageClass.extend({
   name: 'crud-form-class',

   components: { CrudToolbar },

   props: {
      data: {
         type: Object,
         required: false,
         default: null
      },
      dataKey: {
         // type: Number,
         required: false,
         default: null
      },
      modalMode: {
         type: Boolean,
         required: false,
         default: false
      },
      refData: {
         required: false
      },
      newStateTitle: {
         type: String,
         required: false,
         default: null
      },
      editStateTitle: {
         type: String,
         required: false,
         default: null
      },
      updateAllData: {
         type: Boolean,
         default: false
      },
      alwaysUpdate: {
         type: String,
         default: ''
      }
   },

   data () {
      return {
         title: '',
         editKey: null,
         initialData: null,
         initialEditData: null,
         validForm: false,
         formName: 'crudForm',
         formSaved: false,
         formData: null,
         modalTitle: null,
         ttDefault: { //default text-transform for text fields
            'text-transform': 'capitalize'
         },
      };
   },

   computed: {
      newState () {
         return (!this.dataKey && (!this.paramKey || this.paramKey === 0) && !this.editKey);
      },
      paramKey () {
         return (this.modalMode || this.$route.params.id === 'new') ? 0 : this.$route.params.id;
      },
      formKey () {
         return this.dataKey || this.paramKey || this.editKey;
      },
      originalData () {
         return JSON.parse((this.newState) ? this.initialData : this.initialEditData);
      }
   },

   watch: {
      '$store.state.company.selectedStore': function (newVal, oldVal) {
         if (this.newState && this.formData && this.formData.hasOwnProperty('companyId')) {
            this.formData.companyId = newVal;
         }

         //There is also the top root event SELECTED_STORE_CHANGE that can be handled at any component.
         //This method is only regarding the descendant form of this class.
         if (this.selectedStoreChange) this.selectedStoreChange(newVal, oldVal);

      },

      '$route.params.id': function (val) {
         if (!this.formKey) {
            this.$refs[this.formName].reset();
            this.log('param.id. reset', this.formName);
         }

         this.setInitialState();
         this.$nextTick(() => this.setMountedState());

         if (this.onParamsChange) this.onParamsChange(this.paramKey);

      }
   },

   methods: {
      toolbarCommand (command) {
         // console.log(command);

         switch (command) {
            case 'delete':
               this.deleteRecord();
               break;
            case 'restore':
               this.restoreForm();
               break;
            case 'share':
               this.share();
               break;
            case 'print':
               this.print();
               break;
            case 'save':
               this.save();
               break;
            case 'close':
               this.$emit('onClose');
               break;
            case 'block':
               if (this.formData.hasOwnProperty('blocked')) {
                  this.formData.blocked = 1;
                  this.doSave({ blocked: 1 });
               }
               this.$emit('onCommand', command);
               break;
            case 'unblock':
               if (this.formData.hasOwnProperty('blocked')) {
                  this.formData.blocked = 0;
                  this.doSave({ blocked: 0 });
               }
               this.$emit('onCommand', command);
               break;
            case 'back':
               if (!this.formSaved) {
                  this.$emit('onCommand', command);
               } else {
                  this.$emit('onCommand', 'reload');
               }
               break;
            default:
               this.$emit('onCommand', command);
         }
      },

      validFormData (asObj = false) {
         if (this.formData) {
            let data = JSON.parse(JSON.stringify(this.formData));
            Object.keys(data).forEach(k => {
               if (k[0] === '_') delete data[k]; //striping out all keys beginning with _ (underline)
            });
            return (asObj) ? data : JSON.stringify(data);
         }
         return null;
      },

      changedFormData () {
         let data = this.validFormData(true);
         let dataDiff = (this.newState || this.updateAllData) ? data : this.$util.objectDiff(this.originalData, data);

         if (!this.newState) {
            let keys = Object.keys(dataDiff);

            if (this.alwaysUpdate) {
               keys.push(...this.alwaysUpdate.split(','));
            }

            if (keys.length) {
               keys.forEach(k => {
                  k = k.trim();
                  if (Array.isArray(data[k]) || this.alwaysUpdate.indexOf(k) > -1) {
                     dataDiff[k] = data[k];
                  }
               });

            }

         }

         return dataDiff;

      },

      setInitialState () {
         let title;
         if (this.newState) {
            title = this.newStateTitle || `${this.$t('appMsg.newRecord')} ${this.title}`;
         } else {
            title = this.editStateTitle || `${this.$t('appMsg.updateRecord')} ${this.title}`;
         }

         if (this.modalMode) {
            this.modalTitle = title;
         } else {
            this.$store.dispatch('app/setViewTitle', title);
         }

         this.loadFormData();
      },

      setMountedState () {
         //To be user by restoreForm
         if (!this.initialData && this.newState) {
            this.initialData = this.validFormData();
         }
         if (!this.initialEditData && !this.newState) {
            this.initialEditData = this.validFormData();
         }

         if (this.newState && this.$store.state.selectedStore > 0 && this.formData && this.formData.hasOwnProperty('companyId')) {
            this.formData.companyId = this.$store.state.selectedStore;
         }
      },

      validateForm () {
         return new Promise((resolve, reject) => {
            let valid = this.$refs[this.formName].validate();
            if (valid) {
               resolve();
            } else {
               reject();
            }
         });

      },

      save () {
         this.validateForm()
            .then(() => {
               if (this.formData && this.formData.hasOwnProperty('companyId') && this.formData.companyId <= 0) {
                  this.$notifyUser({
                     icon: 'fas fa-hand-point-left',
                     message: this.$t('appMsg.mustChooseCompany'),
                     position: 'top',
                     type: 'error'
                  });
                  return;
               }

               if (this.beforeSave && this.beforeSave()) {
                  return;
               } //skip if beforeSave returns true;

               let changedData = this.changedFormData();
               if (!changedData || JSON.stringify(changedData) === '{}') {
                  this.$notifyUser({
                     type: 'info',
                     message: this.$t('appMsg.nothingChanged')
                  });
                  return;
               }

               this.log('ChangedData: ', this.newState, changedData);

               if (this.saveConfirmation) {
                  this.saveConfirmation(changedData).then(() => this.doSave(changedData)).catch(() => null);
               } else {
                  this.doSave(changedData);
               }

            })
            .catch(() => {
               this.$notifyUser({
                  type: 'error',
                  message: this.$t('appMsg.invalidForm')
               });
            });
      },

      restoreForm () {
         // console.log(this.initialData, this.formData);

         this.$refs[this.formName].reset();
         let initialData = this.originalData;

         if (initialData && this.formData) {
            setTimeout(() => {
               let keys = Object.keys(this.formData);
               let data = initialData;
               keys.forEach(k => {
                  if (data.hasOwnProperty(k)) {
                     this.formData[k] = data[k];
                  }
               });
               if (this.newState && this.formData.hasOwnProperty('companyId')) {
                  this.formData.companyId = this.$store.state.company.selectedStore;
               }
            }, 0);
         }
      },

      share () {
         //TODO: CrudFormClass Share Data
         console.log('Someday we´ll share somehow!');
         // console.log(this.$refs[this.formName].formInputs());
      },

      doSave (data) {
         this.log('doSave: ', data, this.obj);
         this.$api[this.api].save(this.obj, data, this.formKey)
            .then((res) => {
               this.saved = true;
               if (this.afterSave && this.afterSave(res)) {
                  return;
               } //skip default save behavior

               if (this.modalMode) {
                  this.$emit('onDataSaved', res);
               } else {
                  this.formSaved = true;
                  this.saveSuccessMsg();
                  if (!this.formKey) {
                     this.restoreForm();
                  } else { //Making changed values the initial data for change detection
                     this.initialEditData = this.validFormData();
                  }
               }

            });

      },

      deleteRecord () {
         let doDestroy = () => {
            this.$msg.confirm({
               message: this.$t('appMsg.deleteConfirm'),
               title: `${this.$t('appMsg.delete')} ${this.title}`,
               icon: 'warning',
               actions: [this.$t('appMsg.yes'), this.$t('appMsg.dontDelete')],
               defaultAction: 1
            }).then((action) => {
               if (action === 0) {
                  this.$api[this.api].destroy(this.obj, this.formKey).then(() => {
                     this.formSaved = true;
                     this.deleteSuccessMsg();
                     setTimeout(() => this.toolbarCommand('back'), 300);
                  });
               }
            });

         };

         if (this.beforeDelete) //must return a promise
         {
            this.beforeDelete().then(doDestroy);
         } else {
            doDestroy();
         }

      },

      saveSuccessMsg () {
         this.$notifyUser({
            type: 'success',
            message: `${this.title} ${this.$t('appMsg.saved')}!`
         });
      },

      deleteSuccessMsg () {
         this.$notifyUser({
            type: 'success',
            message: `${this.title} ${this.$t('appMsg.successDeleted')}!`,
         });
      },

      setEditState (key, data) {
         this.editKey = key;
         this.loadFormData(null, data);
      },

      loadFormData (thisKey, thisData) {
         let aKey = thisKey || this.formKey;
         // console.log('loadFormData');
         if (this.data || thisData) {
            // console.log('loadFormData - from data Prop');
            if (this.beforeDataLoad) {
               this.beforeDataLoad(thisData || this.data);
            }

            let data = JSON.parse(JSON.stringify(thisData || this.data));

            this.assignData(data);

            this.initialEditData = this.validFormData();

            if (this.afterDataLoad) {
               this.afterDataLoad(data);
            }

         } else if (this.api && aKey) {
            // console.log('loadFormData - API Call');
            this.$api[this.api].getById(this.obj, aKey)
               .then((data) => {
                  // console.log('loadFormData - Data from API Call', JSON.parse(JSON.stringify(data)));
                  if (this.beforeDataLoad) {
                     this.beforeDataLoad(data);
                  }

                  // this.initialData = this.validFormData();

                  this.assignData(data);

                  this.initialEditData = this.validFormData();

                  if (this.afterDataLoad) {
                     this.afterDataLoad(data);
                  }
               })
               .catch((err) => console.error(err));
         }

      },

      assignData (data) {
         console.log('Assign to FormData', data);
         if (!this.newState && !data.hasOwnProperty('id')) console.error('AssignData: data.id is missing!');
         this.$util.updateObj(this.formData, data);
      }

   },

   beforeMount () {
      // console.log('before mounted');
      this.setInitialState();

   },

   mounted () {
      this.setMountedState();

   },

   beforeDestroy () {
      this.modalTitle = null;
      if (!this.modalMode) {
         this.$store.dispatch('app/setViewTitle', null);
      }
   }

})




//////////////////
// WEBPACK FOOTER
// ./node_modules/@consigmais-team/vue-common/layout/crudPage/crudFormClass.js
// module id = zeY2
// module chunks = 0